import { model } from "eco-cli";
import moment from 'moment';
import { sizeConversion } from '../utils/index';

export class File extends model.Model {
    type = 'else' // 'ppt' 'word' 'pdf' 'zip' 'else' else 是其他后缀的文章
    size = '12 MB' // 通过 utils/index.js 中的 sizeConversion 可以进行转换
    url = 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic2.zhimg.com%2Fv2-6811956af35b95220bfe4cdceb20d455_r.jpg&refer=http%3A%2F%2Fpic2.zhimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1662520301&t=2d4853277eeb724211ae392845829527' // 完整的下载 url

    static type(ext) {
        if (ext.indexOf('pdf') >= 0) return 'pdf'
        if (ext.indexOf('ppt') >= 0) return 'ppt' // 支持了 'pptx'
        if (ext.indexOf('doc') >= 0) return 'word' // 支持了 'docx'
        if (ext.indexOf('zip') >= 0) return 'zip'
        if (ext.indexOf('rar') >= 0) return 'zip'
        if (ext.indexOf('7z') >= 0) return 'zip'
        if (ext.indexOf('tar') >= 0) return 'zip'
        if (ext.indexOf('cab') >= 0) return 'zip'
        if (ext.indexOf('iso') >= 0) return 'iso'
        if (ext.indexOf('txt') >= 0) return 'txt'
        if (ext.indexOf('exe') >= 0) return 'exe'
        if (ext.indexOf('xls') >= 0) return 'xls'
        if (ext == '.png' || ext == '.bmp' || ext == '.jpeg' || ext == '.jpg' || ext == '.gif' || ext == '.tiff') return 'jpg'
        if (ext == '.mp4' || ext == '.mov' || ext == '.rmvb' || ext == '.rm' || ext == '.flv' || ext == '.3gp' || ext == '.avi' || ext == '.vob' || ext == '.mpeg' || ext == '.wmv' || ext == '.mpe') return 'mp4'
        return 'else'
    }
    static size(num) {
        return sizeConversion(num)
    }
}

export class BaseArticleItem extends model.Model {
    id = Math.random()
    title = ''

    createTime = moment()
    updateTime = moment()

    url = '' // 项目内的地址，不要加 /vip

    static fromServer(json) {
        return BaseArticleItem.new({
            id: json.id,
            title: json.title,
            createTime: moment(json.createTime),
            updateTime: moment(json.updateTime),
            url: ''
        })
    }
}


// vip 列表
export class VipArticle extends BaseArticleItem {
    type = {
        id: '',
        title: 'SQL 安装', // 一级目录的名字
    }

    isTop = false
    file = new File() // file 为空为文章类型
    pageviews = 0
    downCount = 0
    publishTime = moment()

    abstractData = ''

    constructor(json) {
        super();
        Object.assign(this, json)
    }

    static fromServer(json) {
        const a = new VipArticle({
            ...json,
            ...super.fromServer(json),
            file: json.fileList && json.fileList[0] ?
                Object.assign(new File(), {
                    type: File.type(json.fileList[0].fileSuffix),
                    size: File.size(json.fileList[0].fileSize),
                    url: (model.File.fromServer(json.fileList[0]).downloadUrl)
                }) : null,
            isTop: json.isTop || false,
            publishTime: moment(json.publishTime),
            pageviews: json.scanCount || 0,
            downCount: json.downCount || 0,
            url: `/details/${json.id}`,
            type: {
                id: json.vipType,
                title: json.vipTypeName
            }
        })

        return a
    }
}

export class QuestionArticle extends BaseArticleItem {
    replyCount = 4
}

export class WorkorderArticle extends BaseArticleItem {
    status = 'wait' // wait , process ,solved, complete, rejected
}
export class BugsArticle extends BaseArticleItem {}